function uniq(arr) {
    return [...new Set(arr)];
}

export { uniq };
